/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import './top-wrapper.scss';
import FlashMessage from '@/common/components/flash-message.component';
import AlertMessageComponent from '@/common/components/alert-message/alert-message.component';
import store from '@/common/store/index';
import AppConstants from '@/common/constants/app.constants';
@Component({})
export default class TopWrapper extends Vue {
  ignoredModalIdList: Array<string> = [
    AppConstants.DETAIL_ERROR_MESSAGE_ID_MODAL,
    AppConstants.WARNING_MESSAGE_MODAL_ID
  ];
  inlineMsgModalIdList: Array<string> = [AppConstants.SORTING_MODAL_ID];
  get hideBreadcrumb() {
    return this.$route?.meta?.hideBreadcrumb;
  }

  mounted() {
    this.$root.$on('bv::modal::show', (modal: any) => {
      if (store.getters.getNetworkConnectionMode && !this.ignoredModalIdList.includes(modal.componentId)) {
        FlashMessage.getInstance().hideAllMessages();
      }
      if (this.inlineMsgModalIdList.includes(modal.componentId)) {
        this.$store.commit('setModalMode', true);
      }
    });
    this.$root.$on('bv::modal::hide', (modal: any) => {
      if (store.getters.getNetworkConnectionMode && !this.ignoredModalIdList.includes(modal.componentId)) {
        FlashMessage.getInstance().hideAllMessages();
      }
      if (this.inlineMsgModalIdList.includes(modal.componentId)) {
        this.$store.commit('setModalMode', false);
      }
    });
  }

  render() {
    return (
      <div id="main" class="w-100">
        <div id="header">
          <app-header />
          {!this.hideBreadcrumb || store.getters.getModalMode ? null : <AlertMessageComponent />}
        </div>
        <div id="content-main" class="container-fluid body-content">
          <router-view />
        </div>
      </div>
    );
  }
}
